import gql from 'graphql-tag'

export const QUERY_PRODUCTS = gql`
  query Products($search: String, $eans: [String], $skus: [String], $active: Boolean) {
    products(search: $search, eans: $eans, skus: $skus, active: $active) {
      products {
        _id
        sku
        ean
        eans
        name
        image
      }
    }
  }
`

export const QUERY_GET_PRODUCTS_AND_GROUPS = gql`
  query ProductsAndGroups(
    $search: String
    $ids: [String]
    $skus: [String]
    $active: Boolean
    $sort: [String]
    $sort_direction: [SortDirection]
    $units: [String]
    $measure_acronym: MeasureAcronym
  ) {
    products(
      search: $search
      ids: $ids
      skus: $skus
      active: $active
      sort: $sort
      sort_direction: $sort_direction
      units: $units
      measure_acronym: $measure_acronym
    ) {
      products {
        _id
        sku
        ean
        eans
        name
        image
        categories_final_consumer {
          department {
            _id
            name
          }
          category {
            _id
            name
            department_id
          }
          sub_category {
            _id
            name
            category_id
          }
        }
        units_with_price_1
      }
    }
    productsGroups(search: $search) {
      productsGroups {
        _id
        name
        image_url
        rules_exhibition
        categories_final_consumer {
          department {
            _id
            name
          }
          category {
            _id
            name
            department_id
          }
          sub_category {
            _id
            name
            category_id
          }
        }
      }
    }
  }
`

export const PRODUCTS_SUBSCRIPTION =
  'subscription ValidImportedProducts($roomId: String!) {\n  validImportedProducts(roomId: $roomId) {\n    availableTotal\n    deliveredTotal\n    data {\n      active\n      ean\n      eans\n      _id\n      image\n      name\n      sku\n      units_with_price_1\n      }\n  }\n}'

export const QUERY_ACTIVATE_IMPORTED_PRODUCTS = gql`
  query ActivateImportedProductsJob($eans: [String!]!, $skus: [String!]!, $roomId: String!, $units: [String!]) {
    activateImportedProductsJob(eans: $eans, skus: $skus, roomId: $roomId, units: $units) {
      message
      status
    }
  }
`

export const QUERY_SKU_NAME_PRODUCTS = gql`
  query Products($search: String, $eans: [String], $skus: [String], $active: Boolean, $sort: [String], $sort_direction: [SortDirection]) {
    products(search: $search, eans: $eans, skus: $skus, active: $active, sort: $sort, sort_direction: $sort_direction) {
      products {
        _id
        sku
        name
      }
    }
  }
`
